import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import store, { unleashBinds } from '@/store'
import router from '@/plugins/router'
import firebase from 'firebase/app'
import 'firebase/auth'
import bus from '@/plugins/event-bus'
Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  if (err.message.includes('permission_denied')) {
    // Suppress the warning
    console.warn('Suppressed permission_denied error:', err.message)
  } else {
    // Log other errors
    console.error(err)
  }
}

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App),
  created: function () {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        await this.$store.dispatch('users/bindUsers')
        const me = this.$store.getters['users/getUserById'](user.uid)
        if (!me.approved) {
          await firebase.auth().signOut()
          bus.$emit('toast', 'Your account is awaiting approval.')
        } else {
          await this.$store.dispatch('me/setMe', me)
          unleashBinds()
          if (this.$router.currentRoute.path === '/sign-in') {
            this.$router.push('/')
          }
        }
      } else {
        this.$router.push('/sign-in').catch(() => {})
      }
    })
  },
}).$mount('#app')
